import React from 'react';
import PropTypes from 'prop-types';

export default function ContactDetails({ contact, contactRole, label, renderLinks, showEmployer }) {
  if (label !== false) {
    label = label || (contact.isBusiness ? 'Company' : 'Contact');
    if (contactRole) {
      label = `${label} | ${contactRole.roleLabel}`;
    }
  }

  let { name } = contact;
  if (renderLinks) {
    name = <a href={contact.path}>{name}</a>;
  }

  let businessName;
  if (contact.business && showEmployer) {
    businessName = contact.business.name;
    if (renderLinks) {
      businessName = <a href={contact.business.path}>{businessName}</a>;
    }
  }

  let { email } = contact;
  if (renderLinks && !contact.name) {
    email = <a href={contact.path}>{email}</a>;
  } else {
    email = <a href={`mailto:${contact.email}`}>{email}</a>;
  }

  return (
    <div className="flex-fill">
      <div className="text-muted fs-small">
        {label}
      </div>

      <div>{name}</div>
      <div>{businessName}</div>
      <div>{email}</div>
      <div>{contact.addressFormatted}</div>
      <div>{contact.phoneFormatted}</div>
      <div>{contact.licenseNumber}</div>
    </div>
  );
}

ContactDetails.propTypes = {
  contact: PropTypes.shape({
    addressFormatted: PropTypes.string,
    business: PropTypes.shape({
      name: PropTypes.string,
    }),
    email: PropTypes.string,
    licenseNumber: PropTypes.string,
    name: PropTypes.string,
    phoneFormatted: PropTypes.string,
  }).isRequired,
  contactRole: PropTypes.shape({
    roleLabel: PropTypes.string.isRequired,
  }),
  label: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  renderLinks: PropTypes.bool,
  showEmployer: PropTypes.bool,
};
